import {useNavigate} from '@shopify/hydrogen';
import {ReactNode, useEffect} from 'react';

type RedirectProps = {
  children?: ReactNode;
  to: string;
} & Parameters<ReturnType<typeof useNavigate>>[1];

export default function Redirect({children, to, ...options}: RedirectProps) {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(to, options);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <>{children}</>;
}
